import { render, staticRenderFns } from "./ViolationFilter.vue?vue&type=template&id=270dd81c&scoped=true"
import script from "./ViolationFilter.vue?vue&type=script&lang=js"
export * from "./ViolationFilter.vue?vue&type=script&lang=js"
import style0 from "./ViolationFilter.vue?vue&type=style&index=0&id=270dd81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270dd81c",
  null
  
)

export default component.exports